import { checkIsCorrect, pointsTestToeic } from 'app/utils/test';
import * as categoryConst from 'app/constants/categories';
import Modal from 'app/components/layouts/Modals/Index';
import { Question, Group, Passage } from 'types/test';
import * as testConst from 'app/constants/tests';
import { AppStoreState } from 'app/redux/store';
import { useTranslation } from 'next-i18next';
import ReactDOMServer from 'react-dom/server';
import { useSelector } from 'react-redux';

const ModalChangeTime = (props) => {
  const { isOpen, onClose, timeTest, passagesOfUser, onConfirm } = props;
  const { process, test, result, groupQuestions } = useSelector((state: AppStoreState) => state.test);
  const { t } = useTranslation();
  if (process !== 'complete' || !Object.keys(timeTest).length) {
    return <></>
  }

  const getResultComplete = () => {
    if (!test) return;
    const IS_TOEIC = test?.category_id >= categoryConst.TOEIC_P1 && test?.category_id <= categoryConst.TOEIC_FULL;
    const IS_IELTS = categoryConst.IELTS_TEST.includes(Number(test?.category_id));
    let countQuestionCorrect = 0;
    let countQuestionSelected = 0;
    let countQuestionReadCorrect = 0;
    let countQuestionListenCorrect = 0;
    let MAX_SCORE = IS_TOEIC ? 990 : 10;
    if (IS_IELTS) MAX_SCORE = 9;

    groupQuestions?.forEach((group: Group, indexGroup: number) => {
      group.list_question.forEach((question: Question, indexQuestion: number) => {
        const resultQ = result?.group_questions[indexGroup]?.list_question[indexQuestion];
        const { isCorrect } = checkIsCorrect({ ...question, result: resultQ?.result });
        const numberQuestion = Number(group.number_question);

        if (question.answer) countQuestionSelected += numberQuestion
        if (isCorrect) {
          if (group.part_id && testConst.TOEIC_LISTEN_PARTS.includes(group.part_id)) {
            countQuestionListenCorrect += numberQuestion;
          } else if (group.part_id && testConst.TOEIC_READ_PARTS.includes(group.part_id)) {
            countQuestionReadCorrect += numberQuestion;
          }
          countQuestionCorrect += numberQuestion;
        }
      })
    });

    if (categoryConst.IELT_WRITE == test?.category_id) {
      countQuestionSelected = passagesOfUser.filter((passage: Passage) => passage.content).length;
    }

    let score = 0;
    if (test?.questions_count) {
      score = Number(((MAX_SCORE / test?.questions_count) * countQuestionCorrect).toFixed(1));
    } else if (test?.category_id == categoryConst.TOEIC_MINI || test?.category_id == categoryConst.TOEIC_FULL) {
      score = pointsTestToeic(countQuestionListenCorrect) + pointsTestToeic(countQuestionReadCorrect);
    } else if (test?.category_id >= categoryConst.TOEIC_P1 && test?.category_id <= categoryConst.TOEIC_P4) {
      score = pointsTestToeic(countQuestionListenCorrect);
    } else if (test?.category_id >= categoryConst.TOEIC_P5 && test?.category_id <= categoryConst.TOEIC_P7) {
      score = pointsTestToeic(countQuestionReadCorrect);
    }

    return (
      <div className='content'>
        <div className='question-done'>
          <b>{t('tests.number_question_done2')}</b>:
          <span className="text-info pl-1">{countQuestionSelected}/{test?.questions_count}</span>
        </div>
        <div className={`${categoryConst.IELT_WRITE == test?.category_id ? 'd-none' : ''}`}>
          <b>{t('tests.number_question_correct')}</b>:
          <span className="text-info pl-1">{countQuestionCorrect}/{test?.questions_count}</span>
        </div>
        <div className='time-work-test'>
          <b>{t('tests.homework_time')}</b>:
          <span className="text-info pl-1">{timeTest?.work_time}/{timeTest?.homework_time}</span>
        </div>
        <div className={`${categoryConst.IELT_WRITE == test?.category_id ? 'd-none' : ''}`}>
          <b>{t('tests.your_score')}</b>:
          <span className="text-info pl-1">{score}/{MAX_SCORE}</span>
        </div>
      </div>
    )
  }

  return (
    <Modal
      icon={timeTest.is_time_up ? 'warning' : 'success'}
      title={timeTest.is_time_up ? t('tests.is_time_up_test') : t('tests.submit_test_success')}
      confirmButtonText={t('tests.retest')}
      cancelButtonText={t('commons.cancel')}
      showCancelButton={true}
      show={isOpen}
      onClose={onClose}
      onConfirm={() => onConfirm()}
      html={ReactDOMServer.renderToString(getResultComplete())}
    >
    </Modal>
  )
}

export default ModalChangeTime
